module.exports = __webpack_public_path__ + "assets/img/goodPrize.0dd76888.png";